import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "@/assets/js/models/helpers/JsonMapper";
import ECommerceSdkNoteCollection from "@/assets/js/models/ECommerceSdk/ECommerceSdkNoteCollection";
import ECommerceSdkFieldCollection from "@/assets/js/models/ECommerceSdk/ECommerceSdkFieldCollection";
var _attributes = /*#__PURE__*/new WeakMap();
export default class ECommerceSdk extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [ECommerceSdk.id_attribute_name]: null,
      [ECommerceSdk.name_attribute_name]: null,
      [ECommerceSdk.notes_attribute_name]: ECommerceSdkNoteCollection,
      [ECommerceSdk.fields_attribute_name]: ECommerceSdkFieldCollection,
      [ECommerceSdk.title_attribute_name]: null,
      [ECommerceSdk.image_attribute_name]: null,
      [ECommerceSdk.supported_attribute_name]: false
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getIdAttributeName() {
    return this.id_attribute_name;
  }
  static getNameAttributeName() {
    return this.name_attribute_name;
  }
  static getNotesAttributeName() {
    return this.notes_attribute_name;
  }
  static getFieldsAttributeName() {
    return this.fields_attribute_name;
  }
  static getImageAttributeName() {
    return this.image_attribute_name;
  }
  static getTitleAttributeName() {
    return this.title_attribute_name;
  }
  static getSupportedAttributeName() {
    return this.supported_attribute_name;
  }
  getId() {
    return this.getAttribute(ECommerceSdk.getIdAttributeName());
  }
  getName() {
    return this.getAttribute(ECommerceSdk.getNameAttributeName());
  }
  isSupported() {
    return this.getAttribute(ECommerceSdk.getSupportedAttributeName());
  }
  getNotes() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(ECommerceSdk.getNotesAttributeName())) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : [];
  }
  getImage() {
    return this.getAttribute(ECommerceSdk.getImageAttributeName());
  }
  getTitle() {
    return this.getAttribute(ECommerceSdk.getTitleAttributeName());
  }
  getFields() {
    return this.getAttribute(ECommerceSdk.getFieldsAttributeName());
  }
}
_defineProperty(ECommerceSdk, "id_attribute_name", 'id');
_defineProperty(ECommerceSdk, "name_attribute_name", 'name');
_defineProperty(ECommerceSdk, "notes_attribute_name", 'notes');
_defineProperty(ECommerceSdk, "fields_attribute_name", 'fields');
_defineProperty(ECommerceSdk, "image_attribute_name", 'image');
_defineProperty(ECommerceSdk, "title_attribute_name", 'title');
_defineProperty(ECommerceSdk, "supported_attribute_name", 'supported');